/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ResetPasswordToken200ResponseData } from './ResetPasswordToken200ResponseData'
import {
  ResetPasswordToken200ResponseDataFromJSON,
  ResetPasswordToken200ResponseDataFromJSONTyped,
  ResetPasswordToken200ResponseDataToJSON,
} from './ResetPasswordToken200ResponseData'

/**
 *
 * @export
 * @interface ResetPasswordToken200Response
 */
export interface ResetPasswordToken200Response {
  /**
   *
   * @type {boolean}
   * @memberof ResetPasswordToken200Response
   */
  status: boolean
  /**
   *
   * @type {ResetPasswordToken200ResponseData}
   * @memberof ResetPasswordToken200Response
   */
  data: ResetPasswordToken200ResponseData
}

/**
 * Check if a given object implements the ResetPasswordToken200Response interface.
 */
export function instanceOfResetPasswordToken200Response(
  value: object
): value is ResetPasswordToken200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function ResetPasswordToken200ResponseFromJSON(
  json: any
): ResetPasswordToken200Response {
  return ResetPasswordToken200ResponseFromJSONTyped(json, false)
}

export function ResetPasswordToken200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResetPasswordToken200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: ResetPasswordToken200ResponseDataFromJSON(json['data']),
  }
}

export function ResetPasswordToken200ResponseToJSON(
  value?: ResetPasswordToken200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: ResetPasswordToken200ResponseDataToJSON(value['data']),
  }
}
